import { HStack, VStack } from '@cbhq/cds-web/layout';

import useAllProductFilter from ':cloud/hooks/useAllProductFilter';
import { ProductItem } from ':cloud/types/ts_types';
import { Layout } from ':cloud/widgets/layout';
import { FULL_PAGE_MAX_WIDTH } from ':cloud/widgets/product/constants';
import FilterButtonGroup from ':cloud/widgets/product/FilterButtonGroup';
import { ProductCard } from ':cloud/widgets/product/ProductCard';

export function AllProducts() {
  const { productItems, handleFilterChange, selectedFilters } = useAllProductFilter();

  return (
    <Layout>
      <Layout.MainContainer fullWidth>
        <VStack>
          <FilterButtonGroup
            handleFilterChange={handleFilterChange}
            selectedFilters={selectedFilters}
          />
          <HStack flexWrap="wrap" spacingBottom={5} maxWidth={FULL_PAGE_MAX_WIDTH}>
            {productItems.map((product: ProductItem) => (
              <ProductCard {...product} key={product.title} title={product.title} />
            ))}
          </HStack>
        </VStack>
      </Layout.MainContainer>
    </Layout>
  );
}
